var selectionCtrl = document.querySelector(".store-selection-ctrl-mobile"),
  selectionList = document.querySelector(".store-selecetion-popup-mobile .store-selection-list-country"),
  selectionListItems = document.querySelectorAll(".store-selecetion-popup-mobile .store-selection-list-item-mobile"),
  storeName = document.querySelector("#store--name-country"),
  storeCurrency = document.querySelector(".store-currency"),
  storeSelectionButton = document.querySelector(".store-selecetion-popup-mobile .store-selection-popup--button"),
  modalClose = document.querySelector(".store-selecetion-popup-mobile .store-selection-popup--close");

var storeURL = "self",
  visitingFrom = "AUS",
  visitingCur = "AUD",
  visitingflag = "",
  flagClass = "";

var europeanCountries = [
  "Europe", "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic",
  "Denmark", "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Ireland",
  "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta",  "Poland",
  "Portugal", "Romania", "Slovakia", "Slovenia", "Spain", "Sweden", "Switzerland",
  "Norway"
];

var storeChecked = localStorage.getItem("storeChecked");
var urlParam = location.search.indexOf("redirectFrom");
if (storeChecked || urlParam !== -1) {
  document.querySelector(".store-selecetion-popup-mobile").style.display = "none";
}
if (urlParam !== -1) {
  var urlParams = new URLSearchParams(window.location.search);
  let store = urlParams.get("redirectFrom");
  if (store) {
    store = store.replace("%20", "");
    localStorage.setItem("visitingFrom", store);
    localStorage.setItem("storeChecked", "true");
  }
}

function rebuildSelectionList(current) {
  selectionListItems.forEach(function (el) {
    el.style.display = (current === el) ? "none" : "block";
  });
}

function showVisitingFromMobile() {
  const text = localStorage.getItem("visitingFrom");
  document.querySelectorAll(".visiting-from--text .current-country").forEach(function (el) {
    if (el.classList.length > 1) el.classList.remove(el.classList.item(1));
  });

  if (europeanCountries.includes(text)) {
    setPopupState("europe", "EUR", "Europe", "EUR", "europe");
    $(".countrynameselect").html("Europe");
    $(".store-selection-list-item-mobile.europe").hide();
    console.log(text + ' dddd')
    storeSelectionButton.innerText = `Go to Europe`;
    return;
  }

  switch (text) {
    case "Australia": 
      setPopupState("au", "AUS", "Australia", "AUD", "aud");
      $(".countrynameselect").html("Australia");
      $(".store-selection-list-item-mobile.au").hide();
      storeSelectionButton.innerText = "Go to Australia";
      break;
    case "United Kingdom":
      setPopupState("gbp", "UK", "United Kingdom", "GBP", "gbp");
      $(".countrynameselect").html("United Kingdom");
      $(".store-selection-list-item-mobile.gbp").hide();
      storeSelectionButton.innerText = "Go to United Kingdom";
      break;
    case "New Zealand":
      setPopupState("nz", "NZ", "New Zealand", "NZD", "nzd");
      $(".countrynameselect").html("New Zealand");
      $(".store-selection-list-item-mobile.nz").hide();
      storeSelectionButton.innerText = "Go to New Zealand";
      break;
    case "International":
      setPopupState("int", "INT", "International", "USD", "int");
      $(".countrynameselect").html("International");
      $(".store-selection-list-item-mobile.int").hide();
      storeSelectionButton.innerText = "Go to International";
      break;
    case "United States":
      setPopupState("usd", "USA", "United States", "USD", "usd");
      $(".countrynameselect").html("United States");
      $(".store-selection-list-item-mobile.us").hide();
      storeSelectionButton.innerText = "Go to United States";
      break;
    case "Singapore":
      setPopupState("sgd", "SGP", "Singapore", "SGD", "sgd");
      $(".countrynameselect").html("Singapore");
      $(".store-selection-list-item-mobile.sgd").hide();
      storeSelectionButton.innerText = "Go to Singapore";
      break;
    case "The Netherlands":
      setPopupState("euro", "EUR", "Netherlands", "EUR", "euro");
      $(".countrynameselect").html("Netherlands");
      $(".store-selection-list-item-mobile.euro").hide();
      storeSelectionButton.innerText = "Go to Netherlands";
      break;
    case "Netherlands":
      setPopupState("euro", "EUR", "Netherlands", "EUR", "euro");
      $(".countrynameselect").html("Netherlands");
      $(".store-selection-list-item-mobile.euro").hide();
      storeSelectionButton.innerText = "Go to Netherlands";
      break;  
  }
}

function setPopupState(flag, abbr, name, cur, flagval) {
  document.querySelectorAll(".visiting-from--text .current-country").forEach(function (el) {
    el.classList.add(flag);
    el.innerText = abbr;
  });
  document.querySelectorAll(".store-country").forEach(function (el) {
    el.classList.add(flag);
    el.innerText = name;
  });
  visitingCur = cur;
  visitingflag = flagval;
  visitingFrom =  name;
}

function showSelectionPopupMobile() {
  document.querySelector(".store-selecetion-popup-mobile").style.display = "flex";
}

selectionCtrl.addEventListener("click", function () {
  selectionList.classList.toggle("is-open");
});

selectionListItems.forEach(function (item) {
  item.addEventListener("click", function () {
    storeURL = item.getAttribute("data-link");
    selectionList.classList.remove("is-open");
    storeName.className = "";
    flagClass = item.classList[1];
    storeName.innerText = item.innerText;
    storeName.classList.add("store--name", flagClass);
    visitingFrom = item.innerText;
    visitingCur = item.getAttribute("data-currency");
    visitingflag = item.getAttribute("data-flag");
    storeSelectionButton.innerText = `Go to ${item.innerText}`;
    storeCurrency.innerText = `${visitingCur}`;
    rebuildSelectionList(item);
    storeName.classList.add(visitingflag);
  });
});

storeSelectionButton.addEventListener("click", function () {
  localStorage.setItem("storeChecked", "true");
  localStorage.setItem("visitingFrom", visitingFrom);
  if (visitingCur === "EUR" || visitingCur === "GBP") {
    window.location.href = `https://www.bhumi-organic.com/?redirectFrom=${visitingFrom}`;
  } else if (visitingCur !== "AUD" && visitingCur !== "NZD") {
    window.location.href = `https://bhumiorganic.com/?redirectFrom=${visitingFrom}`;
  } else {
    document.querySelector(".store-selecetion-popup-mobile").style.display = "none";
    $(".currency-selector-auto select").val(visitingCur);
    $(".currency-selector-auto form").submit();
  }
});

modalClose.addEventListener("click", function () {
  localStorage.setItem("storeChecked", "true");
  localStorage.setItem("visitingFrom", "Australia");
  document.querySelector(".store-selecetion-popup-mobile").style.display = "none";
});

$(document).ready(function () {
  
  $(".openpopupmobile").click(function () {
    showSelectionPopupMobile();
  });
});
document.addEventListener('showVisitingFromMobile', () => {
    showVisitingFromMobile();
});